// MetricsTab.js — grid of admin metric tiles + CLI tools panel.

import React from 'react';
import { Grid, Box } from '@mui/material';
import LLMCostTile from './tiles/LLMCostTile';
import LLMCostByFunctionTile from './tiles/LLMCostByFunctionTile';
import LLMCostByUserTile from './tiles/LLMCostByUserTile';
import LLMCostByModelTile from './tiles/LLMCostByModelTile';
import TwilioCostTile from './tiles/TwilioCostTile';
import AlertsTile from './tiles/AlertsTile';
import CostPerCallTile from './tiles/CostPerCallTile';
import CallVolumeTile from './tiles/CallVolumeTile';
import ActiveUsersTile from './tiles/ActiveUsersTile';
import FailureRateTile from './tiles/FailureRateTile';
import LatencyTile from './tiles/LatencyTile';
import CLIToolsPanel from './CLIToolsPanel';

const MetricsTab = () => (
  <Box>
    <Grid container spacing={2}>
      {/* KPI ribbon — single-number quick-glance tiles. */}
      <Grid item xs={12} sm={6} md={4}>
        <CostPerCallTile />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <ActiveUsersTile />
      </Grid>
      <Grid item xs={12} sm={12} md={4}>
        <AlertsTile />
      </Grid>

      {/* Trend pair — LLM and Twilio are structural mirrors
          (Today / 7d / 30d + trend chart), so pair them side-by-side. */}
      <Grid item xs={12} md={6}>
        <LLMCostTile />
      </Grid>
      <Grid item xs={12} md={6}>
        <TwilioCostTile />
      </Grid>

      {/* Breakdown trio — three equal columns. */}
      <Grid item xs={12} md={4}>
        <LLMCostByFunctionTile />
      </Grid>
      <Grid item xs={12} md={4}>
        <LLMCostByUserTile />
      </Grid>
      <Grid item xs={12} md={4}>
        <LLMCostByModelTile />
      </Grid>

      {/* Ops row — full width for the 30-day x-axis to breathe. */}
      <Grid item xs={12}>
        <CallVolumeTile />
      </Grid>

      {/* Ops health — failure rate + decision latency (Phase 4). */}
      <Grid item xs={12} md={6}>
        <FailureRateTile />
      </Grid>
      <Grid item xs={12} md={6}>
        <LatencyTile />
      </Grid>
    </Grid>

    <Box sx={{ mt: 3 }}>
      <CLIToolsPanel />
    </Box>
  </Box>
);

export default MetricsTab;
